const LOCAL_STORAGE_KEYS = {
  CLS_EVENT: 'clsEvent',
  HOMEPAGE_REBOOK: 'homepageRebook',
  CONTACT_MORE_SITTERS: 'contactMoreSitters',
  SITTER_PROFILE_CONTACT_SITTER: 'sitterProfileContactSitter',
};
export default LOCAL_STORAGE_KEYS;
